<template lang='pug'>
  div
    ods-module.main-card(
      shadow="always"
    )
      ods-row(type="flex")
        ods-col.left-container(:span="17")
          div.header
            span {{ $t('predictiveModels.levelsOf') }}
            ods-select.header__selector(
              v-model='nivelType'
              @change="loadChartData"
              :outlined="true"
              placeholder='Select'
              size='hecto')
              ods-option(
                v-for='item in nivelTypes'
                :key='item.value'
                :label='item.label'
                :value='item.value')
            span {{ $t('predictiveModels.inAir') }}
          PollutionChart(ref="pollutionChart" :loadChart="loadChart" :chartData="chartData")
          //- <canvas id="myChart" width="837" height="530"></canvas>

        ods-col.right-container(:span="7")
          div.header
            ods-select.header__selector(
              v-model='sceneType'
              @change="loadChartData"
              :outlined="true"
              placeholder='Select'
              size='hecto')
              ods-option(
                v-for='item in sceneTypes'
                :key='item.value'
                :label='$t(item.label)'
                :value='item.value')
          div.info
            div(v-if="sceneType !== 0")
              div.limit
                div.title
                  span {{ $t('predictiveModels.speedLimit') }}
                div.limit__icons
                  div.limit__icons__signal
                    span {{ speedLimit }}
              div.road
                div.title
                  span M-30
                div.road__container.flex-container
                  div.road__container__tags-container.flex-container(v-for="carTag in carTags")
                    div.road__container__tags-item(:style="{background: carTag.color}")
                      span(:style="carTag.styleObject") {{ carTag.value }}
                    div.road__container__tags-label
                      span {{ carTag.label }}
              div.center-zone
                div.title
                  span {{ $t('predictiveModels.centerZone') }}
                div.center-zone__container.f
                  span {{ $t('predictiveModels.allVehicles') }}

              div.ser-zone
                div.title
                  span Zona SER
                div.ser-zone__container.flex-container
                  div.ser-zone__container__tags-container.flex-container(v-for="carTag in carTagsSer")
                    div.ser-zone__container__tags-item(:style="{background: carTag.color}")
                      span(:style="carTag.styleObject") {{ carTag.value }}
                    div.ser-zone__container__tags-label
                      span {{ carTag.label }}
            div.title(v-else)
              span.empty-message {{ $t('predictiveModels.notRestrictions') }}
 </template>
_
<script>
import PollutionChart from '@/components/predictiveModels/PollutionChart.vue'

export default {
  name: 'PredictiveModelsPollution',
  data () {
    return {
      loadChart: false,
      chartData: {},
      nivelType: 0,
      sceneType: 1,
      speedLimit: 70,
      maxValue: 500,
      minValue: 0,
      nivelTypes: [
        {
          value: 0,
          label: 'NO2'
        }
      ],
      sceneTypes: [
        {
          value: 0,
          label: 'predictiveModels.currentScene'
        },
        {
          value: 1,
          label: 'predictiveModels.infoScene'
        },
        {
          value: 2,
          label: 'predictiveModels.alarmScene'
        }
      ],
      carTags: [],
      carTagsSer: [],
      predictiveDataPart1: [],
      historicalData: []
    }
  },
  computed: {
    getLangData () {
      return this.$store.getters.getLang
    }
  },
  watch: {
    getLangData () {
      this.updateRestrictionData()
    }
  },
  methods: {
    loadChartData () {
      let _this = this
      this.loadChart = true
      let predictiveData = []
      // Adapta mock de valores al escenario seleccionado
      this.maxValue = this.sceneType === 0 ? 200 : this.sceneType === 1 ? 400 : 500
      this.minValue = this.sceneType === 0 ? 20 : this.sceneType === 1 ? 200 : 300

      // Mock datos gráfica. Sustituir por datos reales con servicios
      if (this.predictiveDataPart1.length === 0) {
        this.predictiveDataPart1 = Array.from({length: 7}, () => Math.floor(Math.random() * (this.maxValue - this.minValue) + this.minValue))
      }
      switch (this.sceneType) {
        case 0:
          let part2 = Array.from({length: 6}, () => Math.floor(Math.random() * (500 - 400) + 400))
          predictiveData = this.predictiveDataPart1.concat(part2)
          break
        case 1:
          part2 = Array.from({length: 6}, () => Math.floor(Math.random() * (390 - 350) + 350))
          predictiveData = this.predictiveDataPart1.concat(part2)
          break
        case 2:
          part2 = Array.from({length: 6}, () => Math.floor(Math.random() * (350 - 200) + 200))
          predictiveData = this.predictiveDataPart1.concat(part2)
          break
      }
      if (this.historicalData.length === 0) {
        this.historicalData = Array.from({length: 13}, () => Math.floor(Math.random() * (this.maxValue - this.minValue) + this.minValue))
      }
      const futureData = [...predictiveData]
      const alertLevelData = Array.from({length: 13}, () => 400)
      this.chartData = {
        historicalData: this.historicalData,
        futureData: futureData,
        predictiveData: predictiveData,
        alertLevelData: alertLevelData
      }
      setTimeout(function () {
        _this.loadChart = false
        _this.updateRestrictionData()
      }, 1000)
    },

    // Actualiza los datos de restricciones de la ventana derecha
    updateRestrictionData () {
      // Mock de datos de restricciones. Sustituir por datos reales de servicios
      if (this.sceneType === 2) {
        this.speedLimit = 50
        this.carTags = [
          {value: 'ECO', label: 'ECO', color: '#79C5B4', styleObject: {'font-size': '10px', 'margin-left': '6px'}},
          {value: '0', label: this.$t('predictiveModels.ceroEmissions'), color: '#639FCB', styleObject: {'font-size': '16px', 'margin-left': '10px'}}
        ]
      } else {
        this.speedLimit = 70
        this.carTags = [
          {value: 'B', label: `${this.$t('predictiveModels.type')} B`, color: '#FFEA80', styleObject: {'font-size': '16px', 'margin-left': '10px'}},
          {value: 'C', label: `${this.$t('predictiveModels.type')} C`, color: '#79C5B4', styleObject: {'font-size': '16px', 'margin-left': '10px'}},
          {value: 'ECO', label: 'ECO', color: '#79C5B4', styleObject: {'font-size': '10px', 'margin-left': '6px'}},
          {value: '0', label: this.$t('predictiveModels.ceroEmissions'), color: '#639FCB', styleObject: {'font-size': '16px', 'margin-left': '10px'}}
        ]
      }
      this.carTagsSer = [
        {value: 'ECO', label: 'ECO', color: '#79C5B4', styleObject: {'font-size': '10px', 'margin-left': '6px'}},
        {value: '0', label: this.$t('predictiveModels.ceroEmissions'), color: '#639FCB', styleObject: {'font-size': '16px', 'margin-left': '10px'}}
      ]
      this.$refs.pollutionChart.initLineChart()
    }
  },
  created () {
    this.loadChartData()
  },
  components: {
    PollutionChart
  }

}
</script>

<style lang='scss'>
.main-card {
  height: calc(100vh - 72px);
  margin: rem(22);

  .left-container {
    height: calc(100vh - 72px);
    border-right: 2px solid $--color-grey-light;
    .header {
      margin-top: rem(36);
      span {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      }

      &__selector {
        margin: 0 rem(10)
      }
    }
  }

  .right-container {
    height: calc(100vh - 72px);
    padding: 0 rem(32);
    /* border-left: 2px solid $--color-grey-light; */

    .header {
      margin-top: rem(36);
      span {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      }
    }

    .info {
      margin-top: rem(41);
      .title {
        span {
          font-size: 14px;
          color: $--color--grey-medium;
        }
      }

      .limit__icons {
        &__signal {
          margin-top: rem(4);

          /* Señal velocidad */
          width: rem(41);
          height: rem(41);
          background: #FFFFFF;
          border: 3px solid #DE2F2F;
          border-radius: 30px;
          box-sizing: border-box;

          span{
            color: $--color-grey-dark;
            font-size: 16px;
            font-weight: 500;
            margin-left: rem(8);
          }
        }
      }

      .road {
        margin-top: rem(20);
        &__container {
          flex-wrap: wrap;
          width: rem(260);
          padding: 0 rem(19) rem(19) rem(19);
          background-color: #F9F9FB;

          /* Etiquetas coche */
          /* &__tags{
            height: 29px;
            width: 29px;
            border-radius: 30px;
            margin: rem(20) rem(40) 0 0;

            span {
              color: $--color-grey-dark;
              font-weight: 500;
              line-height: 27px;
            }
          } */
          &__tags-container{
            margin: rem(20) rem(28) 0 0;
          }

          &__tags-item{
            height: rem(29);
            width: rem(29);
            border-radius: 30px;

            span {
              color: $--color-grey-dark;
              font-weight: 500;
              line-height: 27px;
            }
          }

          &__tags-label {
            text-align: center;
            margin-left: rem(5);
            span {
              font-size: 9px;
              display: inline-block;
              vertical-align: middle;
              line-height: normal;
            }
          }
        }
      }

      .center-zone{
        margin-top: rem(20);
        &__container {
          width: rem(260);
          height: rem(53);
          padding: rem(19);
          background-color: #F9F9FB;

          span {
            font-size: 9px;
            color: $--color--grey-medium;
            text-transform: uppercase;
            line-height: rem(50);
          }
        }
      }

      .ser-zone {
        margin-top: rem(20);
        &__container {
          flex-wrap: wrap;
          width: rem(260);
          padding: 0 rem(19) rem(19) rem(19);
          background-color: #F9F9FB;

          /* Etiquetas coche */
          &__tags-container{
            margin: rem(20) rem(36) 0 0;
          }

          &__tags-item{
            height: 29px;
            width: 29px;
            border-radius: 30px;

            span {
              color: $--color-grey-dark;
              font-weight: 500;
              line-height: 27px;
            }
          }

          &__tags-label {
            text-align: center;
            margin-left: rem(5);
            span {
              font-size: 9px;
              display: inline-block;
              vertical-align: middle;
              line-height: normal;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/predictiveModels/PredictiveModelsPollution.vue